import { render, staticRenderFns } from "./creator-list-create-form.vue?vue&type=template&id=8d230932&scoped=true&lang=pug&"
import script from "./creator-list-create-form.vue?vue&type=script&lang=js&"
export * from "./creator-list-create-form.vue?vue&type=script&lang=js&"
import style0 from "./creator-list-create-form.vue?vue&type=style&index=0&id=8d230932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d230932",
  null
  
)

export default component.exports